<template lang="pug">
  .camp-header
    .camp-header__main
      .camp-header__adress(v-if="campAddress") {{ campAddress.region }}, {{ campAddress.area }}
      .camp-header__camp-name(
        v-if="campName"
      ) {{ campName }}
      .camp-header__title
        h1.camp-title {{ title }}
      .camp-header__type(
      v-if="campType"
      ) {{ campType }}
      <!--.camp-header__rating-->
        <!--rating(-->
          <!--:value="rating"-->
        <!--)-->
      .camp-header__tags(
        v-if="tags && tags.length > 0"
      )
        .camp-tags
          .camp-tags__item(
            v-for="tag in tags"
          )
            .camp-tag {{ tag }}
</template>

<script>
import Rating from "@/components/rating/Rating.vue";

export default {
  name: "CampHeader",
  components: {
    Rating
  },
  props: ["campAddress", "campName", "title", "campType", "tags", "rating"]
};
</script>
